export default __webpack_public_path__ + "favicon-32x32.c6b1de4a.png";